export * from './regInfoCPDossier.component';
